export enum ReportMetabaseDashboardEnum {
  SALES_SUMMARY = 147,
  ANALYTICS_REPORT = 140,
}
